import { isObject } from '@zoryn/utils'

import type { ExtractPropTypes, PropType } from 'vue'
import type {
  FormCreateOption,
  FormRule,
  FormSchema,
} from '@zoryn/components/form-create'

export const formDesignerProps = {
  modelValue: {
    type: Object as PropType<FormSchema>,
    default: undefined,
  },
  rule: {
    type: Array as PropType<FormRule[]>,
    default: undefined,
  },
  option: {
    type: Object as PropType<FormCreateOption>,
    default: undefined,
  },
  height: {
    type: [String, Number],
    default: '100%',
  },
  mask: {
    type: Boolean,
    default: true,
  },
  config: {
    type: Object as PropType<Record<string, unknown>>,
    default: undefined,
  },
} as const

export type FormDesignerProps = ExtractPropTypes<typeof formDesignerProps>

export const formDesignerEmits = {
  'update:modelValue': (value: FormSchema) => isObject(value),
  'update:rule': (value: FormRule[]) => Array.isArray(value),
  'update:option': (value: FormCreateOption) => isObject(value),
}

export type FormDesignerEmits = typeof formDesignerEmits
